import React from 'react';

const BaseInput = ({ className, ...props }) => {
    return (
        <input className={`${className} p-2 border border-primary rounded-sm `} {...props} />
    );
};

export default BaseInput;
